module.exports = __webpack_public_path__ + "img/linkedin-icon.ad33115.svg";